import { Button, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText } from '@material-ui/core/'
import PropTypes from 'prop-types'
import { Form } from 'react-final-form'

export default function DialogOptions({ content, title, options, open, setOpen }) {
  if (!open) return <></>
  const handleClose = async () => {
    setOpen(false)
  }
  return (
    <Form
      initialValues={{}}
      onSubmit={() => { }}
      render={({ values }) => <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title" onEscapeKeyDown={handleClose}>
        <DialogTitle id="form-dialog-title">{title}</DialogTitle>
        <DialogContent>
          {typeof content === 'string' ? <DialogContentText>{content}</DialogContentText> : content}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">Cancel</Button>
          {options.map(e => <Button key={e.content} color="primary" onClick={() => e.action(values)}>{e.content}</Button>)}
        </DialogActions>
      </Dialog>
      } />
  )
}

DialogOptions.propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  title: PropTypes.string,
  options: PropTypes.array.isRequired,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired
}